import { Row, Container, Image, Col } from "react-bootstrap";
import SafariParkSearch from "./SafariParkSearch";
import { common } from "Data/common";

const HomeBanner = () => {

  return (
    <section className="banner_section main_homebanner position-relative">
      <picture className="position-relative">
        <source
          srcSet={"/img/baneer1744634301.jpg"}
          media="(max-width:576px)"
          type="image/jpg"
        />
        <Image
          src="/img/baneer1744634301.jpg"
          className="d-block w-100"
          alt="banner"
          type="image/jpg"
          loading="lazy"
        />
      </picture>
      <div className="banner_searchBox">
        <Container fluid="lg">
          <Row>
            <Col xs={12}>
              <div className="headingBnner pb-1">
                <h1>
                  {common?.HOME_BANNER?.HEADING}
                </h1>
              </div>
            </Col>
            <Col className="pt-4">
              <div className="tab-block" id="tab-block">
                <div className="tab-cont">
                  <div className="tab-pane">
                    <SafariParkSearch />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
}

export default HomeBanner;
